import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/*
 * SpinParams.ts
 */
export class SpinParams {
    constructor(messageAcknowledged, roomName) {
        this.messageAcknowledged = messageAcknowledged;
        this.roomName = roomName;
    }
    liquify() {
        let data = new DataObject();
        data.putString(SlingoConstants.PROPERTY_ROOM_NAME, this.roomName);
        data.putBoolean(SlingoConstants.PROPERTY_MESSAGE_ACKNOWLEDGED, this.messageAcknowledged);
        return data;
    }
}
//# sourceMappingURL=SpinParams.js.map